<div class="loaderContentImg">
    <img src="../../../assets/main/no-result-found.png" alt="No Result">
    <h4>Unable to book flight</h4>
    <p>Sorry! We are unable to book this flight due to {{matData?.error?.message ? matData?.error?.message : 'technical issue'}}</p>
    <button mat-button color="primary" class="searchAgain" (click)="searchAgain()">Search again</button>
</div>